import * as types from "../actions/types";

const initialState = {
  list: null,
  loading: false
};


export default function roomTypes (state = initialState, action) {
  switch (action.type) {
    case types.SET_ROOM_TYPES:
      return {
        ...state,
        list: action.payload
      };
    case types.SET_ROOM_TYPES:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}